<template>
  <ColorPicker
    :defaultColor="defaultColor"
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
  />
</template>

<script>
export default {
  name: 'AppColorPicker',
  props: {
    defaultColor: String,
    modelValue: String,
  },
};
</script>

<style scoped>
div >>> .p-colorpicker-preview {
  height: 24px;
}
.p-colorpicker {
    width: 80px;
    height: 32px;
    padding: 3px;
    border: 1px solid #ced4da;
    border-radius: 3px;
}
</style>